import {IAppRoute} from "../config/IAppRoute";
import {AppVersion} from "../pages/AppVersion";

export const routeAppVersion: IAppRoute = {
  menuId: '',
  title: 'App version',
  routePath: '/app/version',
  getRoutePath: () => routeAppVersion.routePath,
  userHasAllRights: [],
  userHasAnyOfRights: [],
  exact: true,
  render: () => <AppVersion/>,
};
